import { CategorieCritereEnum } from './enums/categorie-critere.enum';
import { MontantMarcheEnum } from './enums/montant-marche.enum';

export class MontantMarche {

    public code: MontantMarcheEnum;
    public libelle: String;
    public categorie: string = CategorieCritereEnum[CategorieCritereEnum.CATAGORIE_3];

}
